// src/store/index.js
import Vue from "vue";
import Vuex from "vuex";
import config from "./modules/config";
import persistedstate from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    config,
  },
  plugins: [
    // 持久化config模块的state
    persistedstate({
      paths: ["config"],
    }),
  ],
});
